import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/.pnpm/next-sanity@7.1.4_@sanity+client@6.29.1_@sanity+icons@2.11.8_@sanity+types@3.99.0_@sanity+ui@_ldohoormt2oyxzayxm4mxjkeba/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1_sass@1.97.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1_sass@1.97.3/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_for-patient/instructions/instructions-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_global/faq/faq-list.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_global/hero/hero.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_global/localization/localization.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_for-patient/instructions/instructions.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CopyToClipboard"] */ "/vercel/path0/next/src/components/_global/localization/localizations-copy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_global/newsletter/newsletter-form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/ui/button/button.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/ui/button-big/button-big.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_services/freebie/freebie.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_global/faq/faq.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_for-patient/test-localizations/test-localizations.module.scss");
